import './ContactSupport.scss';
import { useEffect } from 'react';
import { show } from '@intercom/messenger-js-sdk';
import { Alert } from 'antd';
import { BOOK_CALL_CALENDLY_URL } from 'src/constants';
import { useAppSelector } from '@/store/hooks/useAppSelector';
import { getLoggedInUser } from '@/store/account/selector';

export const ContactSupport = () => {
	useEffect(() => {
		show();
	}, []);

	const loggedInUser = useAppSelector(getLoggedInUser);
	const baseClass = 'contact-support';

	return (
		<>
			<Alert
				className="overview-info"
				closable
				description="Get in touch with Support in just minutes! 👇"
			/>
			<div className={baseClass}>
				<iframe
					src={`${BOOK_CALL_CALENDLY_URL}?a1=${encodeURIComponent(loggedInUser.username || '')}`}
					title="Calendly"
					className={`${baseClass}__content`}
				/>
			</div>
		</>
	);
};
